module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/axios/index.js
// module id = 103
// module chunks = 29